import { render, staticRenderFns } from "./allloans.vue?vue&type=template&id=39ce2a82&scoped=true"
import script from "./allloans.vue?vue&type=script&lang=js"
export * from "./allloans.vue?vue&type=script&lang=js"
import style0 from "./allloans.vue?vue&type=style&index=0&id=39ce2a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce2a82",
  null
  
)

export default component.exports